const ROBIN_HATS = [
  {
    slug: "robin-blue-1",
    name: "Robin",
    description: "Hero of the woods",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 20
      },
      {
        stat: "blueRes",
        value: 10
      },
      {
        stat: "goldColor",
        value: 6
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 1
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "robinette-pink-1",
    name: "Robinette",
    description: "Heroine of the woods",
    rarity: "epic",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 35
      },
      {
        stat: "goldRes",
        value: 15
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 1
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "robin-green-1",
    name: "Robin",
    description: "Hero of the woods",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 20
      },
      {
        stat: "greenRes",
        value: 10
      },
      {
        stat: "blueColor",
        value: 6
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 1
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "robin-purple-1",
    name: "Robin",
    description: "Hero of the woods",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 20
      },
      {
        stat: "blueRes",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_purple",
      frameIndex: 1
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "robin-red-1",
    name: "Robin",
    description: "Hero of the woods",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 20
      },
      {
        stat: "redRes",
        value: 10
      },
      {
        stat: "blackColor",
        value: 6
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 1
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "robin-yellow-1",
    name: "Robin",
    description: "Hero of the woods",
    rarity: "rare",
    slot: "hat",
    statChanges: [
      {
        stat: "goldColor",
        value: 20
      },
      {
        stat: "goldRes",
        value: 10
      },
      {
        stat: "greenColor",
        value: 6
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_yellow",
      frameIndex: 1
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  }
];
export {
  ROBIN_HATS
};
//# sourceMappingURL=data:application/json;base64,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
